import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
import { Link, Text } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { AccessibilityLink } from '~/src/components/accessibility-link';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h2>{`Usage`}</h2>
    <p>{`Toasts are used to provide relevant feedback to the user, typically after they've taken an action. Primer includes styles for success, warning, error, loading, and default toasts. Some examples include:`}</p>
    <ul>
      <li parentName="ul">{`Confirmation that an action was successfully taken`}</li>
      <li parentName="ul">{`Communicating that an action is pending`}</li>
      <li parentName="ul">{`Notifying the user if an action failed to complete`}</li>
      <li parentName="ul">{`Providing general information`}</li>
    </ul>
    <p>{`Toasts are best used in context of the page they're referring to (rather than a global notification that can appear on any page) and should require minimal user interaction. Toasts are best used to display time-sensitive information. For global notices and messaging, see the `}<a parentName="p" {...{
        "href": "/components/flash"
      }}>{`flash component`}</a>{`.`}</p>
    <p>{`Toasts should be brief and not bog down the experience with superfluous copy. If multiple toasts appear on the page, they will stack naturally.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/586552/63106528-06de5100-bf51-11e9-8a5e-98583ed74874.png" />
    <Caption mdxType="Caption">Use brief and direct communication.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/586552/63106527-06de5100-bf51-11e9-858c-72de6a5c728a.png" />
    <Caption mdxType="Caption">Don't use wordy and redundant copy, and avoid exceeding 140 characters.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Accessibility`}</h2>
    <p>{`Toasts are non-modal components and should contain `}<inlineCode parentName="p">{`role=log`}</inlineCode>{`, which implies the element has `}<inlineCode parentName="p">{`aria-live="polite"`}</inlineCode>{`. This notifies the user of the toast via Assistance Technologies without having to change focus to the toast. You can read more about `}<inlineCode parentName="p">{`role=log`}</inlineCode>{` at `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/WCAG21/Techniques/aria/ARIA23"
      }}>{`W3: Using `}<inlineCode parentName="a">{`role=log`}</inlineCode>{` to identify sequential information updates`}</a>{`.`}</p>
    <p>{`Toasts are generally informative and should not receive focus when they appear. For that reason, we suggest you `}<strong parentName="p">{`avoid using interactive elements`}</strong>{` in the component (aside from a dismiss action). Keep in mind that, even without an explicit dismiss action, the user can always hit `}<inlineCode parentName="p">{`esc`}</inlineCode>{` to dismiss the toast. For more information on how interactive children affect web accessibility, `}<a parentName="p" {...{
        "href": "https://github.com/jackbsteinberg/std-toast/issues/29"
      }}>{`check out this issue`}</a>{`.`}</p>
    <h3>{`Known accessibility issues (GitHub staff only)`}</h3>
 <AccessibilityLink label="Toast" mdxType="AccessibilityLink" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      